var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import { HorizonJs_Uuid } from "horizon-js-sdk/lib/HorizonJs_Uuid";
import Moment from "horizon-js-front-sdk/lib/Moment";
import { Payment, PaymentStatus } from "./Payment";
import Purchase from "./Purchase";
import { OrderExtras } from "./OrderExtras";
import Ticket from "../Ticketing/Ticket";
import PaymentRefund, { PaymentRefundStatus } from "./PaymentRefund";
var UuidType;
(function (UuidType) {
    UuidType["NIL"] = "00000000-0000-0000-0000-000000000000";
    UuidType["LAST"] = "ffffffff-ffff-ffff-ffff-ffffffffffff";
    UuidType["GHOST"] = "ffffffff-ffff-ffff-ffff-ffffffffffff";
})(UuidType || (UuidType = {}));
var Order = /** @class */ (function (_super) {
    __extends(Order, _super);
    /**
     * Construct a product from a javascript object of a json string
     * @param obj either a javascript object or a json string
     * @param generateUuid
     */
    function Order(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.establishmentUid = null;
        _this.creationDate = Moment.getUTCDate(new Date());
        _this.purchases = [];
        _this.price = 0;
        _this.priceWithTax = 0;
        _this.totalPrice = 0;
        _this.totalPriceWithTax = 0;
        _this.billingAddressUid = "00000000-0000-0000-0000-000000000000";
        _this.sellerProfileUid = null;
        _this.buyerProfileUid = null;
        _this.cashStatementUid = null;
        _this.tickets = null;
        _this.extras = new OrderExtras();
        _this.payments = [];
        _this.paymentRefunds = [];
        _this.sendByEmail = true;
        /** From API **/
        _this._totalPayments = 0;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Order.buildFromJson(_this, obj);
        return _this;
    }
    Order.prototype.leftToPay = function (status_canceled) {
        return this.get_total_price_with_tax(status_canceled) - (this.totalPayments);
    };
    Object.defineProperty(Order.prototype, "totalRefund", {
        get: function () {
            var total = 0;
            for (var _i = 0, _a = this.paymentRefunds; _i < _a.length; _i++) {
                var refund = _a[_i];
                if (refund.status === PaymentRefundStatus.SUCCESS || refund.status === PaymentRefundStatus.PENDING) {
                    total += refund.amount;
                }
            }
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "totalPayments", {
        get: function () {
            if (this._totalPayments > 0) {
                return this._totalPayments;
            }
            var totalPayment = 0;
            for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
                var payment = _a[_i];
                if (payment.amount !== undefined) {
                    totalPayment += payment.amount;
                }
            }
            return totalPayment;
        },
        set: function (value) {
            this._totalPayments = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "fees", {
        get: function () {
            var _a;
            var fees = 0;
            for (var _i = 0, _b = this.payments; _i < _b.length; _i++) {
                var payment = _b[_i];
                if (payment.paymentStatus === 'PAID') {
                    fees += (_a = payment.fees) !== null && _a !== void 0 ? _a : 0;
                }
            }
            return fees;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * builds the class instance from a javascript object
     * @param instance this
     * @param json javascript object
     */
    Order.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'purchases') {
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance.purchases.push(new Purchase(subProp));
                        }
                    }
                    else if (prop === 'payments') {
                        for (var _b = 0, _c = json[prop]; _b < _c.length; _b++) {
                            var subProp = _c[_b];
                            instance.payments.push(new Payment(subProp));
                        }
                    }
                    else if (prop === 'paymentRefunds') {
                        for (var _d = 0, _e = json[prop]; _d < _e.length; _d++) {
                            var subProp = _e[_d];
                            instance.paymentRefunds.push(new PaymentRefund(subProp));
                        }
                    }
                    else if (prop === 'creationDate' || prop === 'paymentDate') {
                        instance[prop] = json[prop];
                    }
                    else if (prop === 'totalPriceWithTax'
                        || prop === 'totalPrice'
                        || prop === 'priceWithTax'
                        || prop === 'price') {
                        instance[prop] = json[prop];
                    }
                    else if (prop === 'totalPayment') {
                        instance._totalPayment = json[prop];
                    }
                    else if (prop === 'extras') {
                        instance[prop] = new OrderExtras(json[prop]);
                    }
                    else if (prop === 'fees') {
                    }
                    else if (prop === 'tickets') {
                        if (json[prop] !== null) {
                            instance.tickets = [];
                            for (var _f = 0, _g = json[prop]; _f < _g.length; _f++) {
                                var subProp = _g[_f];
                                instance.tickets.push(new Ticket(subProp));
                            }
                        }
                        else {
                            instance[prop] = json[prop];
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Order.prototype.exportToJson = function () {
        var JSONOrder = {};
        JSONOrder.uid = this.uid;
        JSONOrder.customer = this.customer;
        JSONOrder.userCustomerUid = this.userCustomerUid;
        JSONOrder.invoiceUid = this.invoiceUid;
        JSONOrder.invoiceFeesUid = this.invoiceFeesUid;
        JSONOrder.creationDate = this.creationDate;
        JSONOrder.establishmentUid = this.establishmentUid;
        JSONOrder.price = this.price;
        JSONOrder.priceWithTax = this.priceWithTax;
        JSONOrder.totalPrice = this.totalPrice;
        JSONOrder.totalPriceWithTax = this.totalPriceWithTax;
        JSONOrder.hasTicket = this.hasTicket;
        JSONOrder.billingAddress = this.billingAddress;
        JSONOrder.cashStatementUid = this.cashStatementUid;
        JSONOrder.purchases = [];
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var item = _a[_i];
            JSONOrder.purchases.push(item.exportToJson());
        }
        JSONOrder.billingAddressUid = this.billingAddressUid;
        JSONOrder.sellerProfileUid = this.sellerProfileUid;
        JSONOrder.buyerProfileUid = this.buyerProfileUid;
        JSONOrder.extras = this.extras.exportToJson();
        JSONOrder.payments = [];
        for (var _b = 0, _c = this.payments; _b < _c.length; _b++) {
            var item = _c[_b];
            JSONOrder.payments.push(item.exportToJson());
        }
        JSONOrder.paymentRefunds = [];
        for (var _d = 0, _e = this.paymentRefunds; _d < _e.length; _d++) {
            var item = _e[_d];
            JSONOrder.paymentRefunds.push(item.exportToJson());
        }
        JSONOrder.sendByEmail = this.sendByEmail;
        return JSONOrder;
    };
    Order.prototype.generateUid = function (allChilds) {
        if (allChilds === void 0) { allChilds = false; }
        if (this.uid === null) {
            this.uid = HorizonJs_Uuid.v4();
        }
        for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            payment.generateUid();
        }
        if (allChilds) {
            for (var _b = 0, _c = this.purchases; _b < _c.length; _b++) {
                var purchase = _c[_b];
                purchase.generateUid(allChilds);
            }
        }
    };
    Order.prototype.search_uid = function (uid) {
        if (this.uid === uid) {
            return this;
        }
        else {
            for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
                var p = _a[_i];
                var current_search = p.search_uid(uid);
                if (p.search_uid(uid) !== null) {
                    return current_search;
                }
            }
            for (var _b = 0, _c = this.payments; _b < _c.length; _b++) {
                var py = _c[_b];
                if (py.uid === uid) {
                    return py;
                }
            }
        }
        return null;
    };
    Order.prototype.isPaid = function (statusCanceled) {
        if (statusCanceled === void 0) { statusCanceled = null; }
        var totalPaid = 0;
        for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            if (payment.paymentStatus === PaymentStatus.PAID && payment.amount !== undefined) {
                totalPaid += payment.amount;
            }
        }
        if (statusCanceled) {
            return this.get_total_price_with_tax(statusCanceled) === totalPaid;
        }
        else {
            return this.totalPriceWithTax === totalPaid;
        }
    };
    Order.prototype.getUsedPaymentMethods = function () {
        var _a, _b;
        var mergePayment = [];
        for (var _i = 0, _c = this.payments; _i < _c.length; _i++) {
            var p = _c[_i];
            //On regarde si c'est un payement normal ou un remboursement.
            if (((_a = p.amount) !== null && _a !== void 0 ? _a : 0) > 0) {
                mergePayment.push({ payment: p, canceled: null });
            }
        }
        for (var _d = 0, _e = this.payments; _d < _e.length; _d++) {
            var p = _e[_d];
            //On regarde si c'est un payement normal ou un remboursement.
            if (((_b = p.amount) !== null && _b !== void 0 ? _b : 0) <= 0) {
                //On est dans le cas d'un remboursement.
                //On regarde si c'est l'annulation d'un payment précis.
                var is_a_canceled_payment = false;
                for (var _f = 0, mergePayment_1 = mergePayment; _f < mergePayment_1.length; _f++) {
                    var mp = mergePayment_1[_f];
                    if (mp.canceled === null) {
                        if (is_invert_payment(mp.payment, p)) {
                            mp.canceled = p;
                            is_a_canceled_payment = true;
                            break;
                        }
                    }
                }
                //Si ce n'est pas le cas on le push simplement.
                if (!is_a_canceled_payment) {
                    mergePayment.push({ payment: p, canceled: null });
                }
            }
        }
        var methods = [];
        for (var _g = 0, mergePayment_2 = mergePayment; _g < mergePayment_2.length; _g++) {
            var mergedPayment = mergePayment_2[_g];
            if (mergedPayment.canceled === null && mergedPayment.payment.paymentMethodUid && !methods.includes(mergedPayment.payment.paymentMethodUid)) {
                methods.push(mergedPayment.payment.paymentMethodUid);
            }
        }
        return methods;
        function is_invert_payment(p1, p2) {
            var _a;
            return p1.amount === -((_a = p2.amount) !== null && _a !== void 0 ? _a : 0)
                && p1.paymentMethodUid === p2.paymentMethodUid
                && is_root_purchase_same(p1.rootPurchases, p2.rootPurchases);
            function is_root_purchase_same(root1, root2) {
                for (var _i = 0, root1_1 = root1; _i < root1_1.length; _i++) {
                    var p1Uid = root1_1[_i];
                    var isIn = false;
                    for (var _a = 0, root2_1 = root2; _a < root2_1.length; _a++) {
                        var p2Uid = root2_1[_a];
                        if (p1Uid === p2Uid) {
                            isIn = true;
                            break;
                        }
                    }
                    if (!isIn) {
                        return false;
                    }
                }
                return true;
            }
        }
    };
    Order.prototype.isCreated = function () {
        //Is this state there is no waiting payment.
        return this.totalPriceWithTax > 0 && this.payments.length === 0;
    };
    Order.prototype.isError = function () {
        for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            if (payment.paymentResultCode !== 0 || payment.paymentStatus === PaymentStatus.ERROR) {
                return true;
            }
        }
        return false;
    };
    Order.prototype.getError = function () {
        for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            if (payment.paymentResultCode !== 0 && payment.paymentResultCode !== undefined) {
                return payment.paymentResultCode;
            }
        }
        return 0;
    };
    Order.prototype.isRefund = function () {
        return false;
    };
    Order.prototype.isWaiting = function () {
        for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            if (payment.paymentStatus === PaymentStatus.PENDING) {
                return true;
            }
        }
        return false;
    };
    Order.prototype.isCanceled = function () {
        if (this.payments.length === 0)
            return true;
        for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            if (payment.paymentStatus === PaymentStatus.CANCELED) {
                return true;
            }
        }
        return false;
    };
    Order.prototype.isInvoiceOrderAvailable = function () {
        return this.invoiceUid !== null && this.invoiceUid !== UuidType.NIL;
    };
    Order.prototype.isWaitingOrderInvoice = function () {
        return this.invoiceUid === null;
    };
    Order.prototype.isOrderHaveNoInvoice = function () {
        return !(this.isInvoiceOrderAvailable() && !this.isWaitingOrderInvoice());
    };
    Order.prototype.isInvoiceFeesAvailable = function () {
        return this.invoiceFeesUid !== null && this.invoiceFeesUid !== UuidType.NIL;
    };
    Order.prototype.isWaitingFeesInvoice = function () {
        return this.invoiceFeesUid === null;
    };
    Order.prototype.isManualOrder = function () {
        return this.userCustomerUid === UuidType.GHOST;
    };
    Order.prototype.isRefundAvailable = function () {
        return this.invoiceUid !== null;
    };
    Order.prototype.getAmountOfVAT = function (vat, status_canceled_uid) {
        var totalVAT = 0;
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            totalVAT += purchase.getAmountOfVAT(vat, status_canceled_uid);
        }
        return totalVAT;
    };
    Order.prototype.get_total_price_with_tax = function (status_canceled_uid, params) {
        if (params === void 0) { params = null; }
        var total_price_with_tax = 0;
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            total_price_with_tax += purchase.getPriceWithTax(status_canceled_uid, params);
        }
        return total_price_with_tax;
    };
    Order.prototype.getProductsNumber = function (statusCanceled) {
        var productsNumber = 0;
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            productsNumber += purchase.get_sum_items(statusCanceled);
        }
        return productsNumber;
    };
    Order.prototype.getQuantityByLevel = function () {
        var qtyByLevel = {};
        qtyByLevel["0"] = 0;
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var product = _a[_i];
            product.getQuantityByLevel(0, qtyByLevel);
        }
        return qtyByLevel;
    };
    Order.prototype.getPurchase = function (purchaseUid) {
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            var childPurchase = purchase.getPurchase(purchaseUid);
            if (childPurchase !== null) {
                return childPurchase;
            }
        }
        return null;
    };
    Order.prototype.getParentPurchaseOfPurchase = function (childPurchaseUid) {
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            var childPurchase = purchase.getPurchase(childPurchaseUid);
            if (childPurchase !== null) {
                return purchase;
            }
        }
        return null;
    };
    Order.prototype.add_product = function (params) {
        var product = params.product;
        if (product.uid) {
            /** On regarde si le produit est dénombrable **/
            // if (product.quantitySelector.isProductUniquable) {
            /** Le produit est dénombrable **/
            /** On créé un nouveau purchase **/
            var purchase_in_order = new Purchase().add_product({
                product: product,
                replaceOrAdd: "ADD",
                quantity: params.quantity,
                statusCanceled: params.statusCanceled,
                currentContext: params.currentContext
            });
            if (purchase_in_order !== null) {
                /** Si tout est bon on l'ajoute puis on le renvoie **/
                this.purchases.push(purchase_in_order);
                return purchase_in_order;
            }
            // } else {
            // 	/** Le produit est indénombrable **/
            // 	let purchases_in_order: Purchase[] = this.found_in_order(product);
            // 	let purchase_selected: Purchase | null = null;
            // 	let is_already_in_order: boolean = true;
            // 	if (purchases_in_order.length > 0) {
            // 		for (let purchase of purchases_in_order) {
            // 			/** On test si un des purchase est éligible à l'ajout d'un produit **/
            // 			/** C'est à dire est ce que l'on peut modifier sa quantité
            // 			 * DONC il doit être dans le cart et indénombrable
            // 			 * **/
            // 			if (purchase.is_same_status_as_current(params.statusCart).isOk) {
            // 				purchase_selected = purchase;
            // 			}
            // 		}
            // 	}
            // 	/** Si aucun purchase n'est trouvé OU qu'aucun purchase n'est élligible on en créé un nouveau **/
            // 	if (purchase_selected === null) {
            // 		is_already_in_order = false;
            // 		purchase_selected = new Purchase();
            // 	}
            //
            // 	/** Pour vérifier que le add se fasse bien **/
            // 	purchase_selected = purchase_selected.add_product({
            // 		product: product,
            // 		quantity: params.quantity,
            // 		replaceOrAdd: "ADD",
            // 		statusCanceled: params.statusCanceled,
            // 		currentContext: params.currentContext
            // 	});
            //
            // 	/** On ajoute le purchase si c'est un nouveau **/
            // 	if (!is_already_in_order && purchase_selected) {
            // 		this.purchases.push(purchase_selected);
            // 	}
            //
            // 	/** On retourne ce purchase | Soit le nouveau, soit le modifié **/
            // 	return purchase_selected;
            //
            // }
        }
        else {
            console.warn("ProductUid is null\n", "File : Order.ts\n", "Object : Order\n", "Function : add_product()\n");
        }
        return null;
    };
    Order.prototype.is_closed = function (statusCanceled) {
        return this.get_total_price_with_tax(statusCanceled) === this.totalPayments;
    };
    Order.prototype.found_in_order = function (product) {
        var purchases = [];
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            if (purchase.productUid === product.uid) {
                purchases.push(purchase);
            }
        }
        return purchases;
    };
    Order.prototype.getTotalQuantity = function () {
        var quantity = 0;
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            for (var _b = 0, _c = purchase.items; _b < _c.length; _b++) {
                var item = _c[_b];
                quantity += item.quantity;
            }
        }
        return quantity;
    };
    Order.prototype.requireSuppData = function (suppData) {
        for (var _i = 0, _a = this.purchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            if (purchase.requireSuppData(suppData)) {
                return true;
            }
        }
        return false;
    };
    return Order;
}(Model));
export default Order;
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["WAITING_PAYMENT"] = "WAITING_PAYMENT";
    OrderStatus["PAID_ERROR"] = "PAID_ERROR";
    OrderStatus["CREATED"] = "CREATED";
    OrderStatus["PAID"] = "PAID";
    OrderStatus["FULL_REFUND"] = "FULL_REFUND";
})(OrderStatus || (OrderStatus = {}));
//# sourceMappingURL=Order.js.map